export default __webpack_public_path__ + "static/media/AD_Logo_White.1686e9a7.svg";